import AccordionItem from './AccordionItem';
import { DescripUnion } from '@Models/types';

interface AccordionProps<T> {
  items: T[];
  onProcess: (item: T, selected: boolean) => void;
  selectedItems: T[];
  renderContent: (item: T) => React.ReactNode; // Function to render the content
}

//union type for jira integration
const Accordion = <T extends DescripUnion>({
  items,
  onProcess,
  selectedItems,
  renderContent,
}: AccordionProps<T>) => {
  const getId = (item: DescripUnion): string => {
    if ('reference_num' in item) {
      return item.reference_num; //aha
    }
    return item.key; //jira
  };

  return (
    <div className="w-full rounded border">
      {items.map((item) => {
        const itemId = getId(item);

        return (
          <AccordionItem
            key={itemId}
            item={item}
            isSelected={selectedItems.some((i) => getId(i) === itemId)}
            onSelect={onProcess}
            renderContent={renderContent}
          />
        );
      })}
    </div>
  );
};

export default Accordion;
